// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format8 } from '../../constants';

/** Azerbaijan */
const AZ: PhoneNumberData = [994, 'AZ', 9, format8];

export default AZ;
